/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import { Auth } from 'aws-amplify';
import React,{useState} from 'react'
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/Loader';
import ErrorMessage from '../../../components/ErrorMessage';
import GlobalContext from '../../../components/Context/GloablContext';
import { passwordCriteria } from '../../auth/passwordCriteria';
import { dataService } from '../../../services/data.services';
import { logout } from '../../auth/authSlice';
import CardHeader from '../../../components/CardHeader';
import Toast from '../../../components/Toast'


const UpdateProfilePassword = () => {
    const {setToastmessage} =useContext(GlobalContext)
    const dispatch=useDispatch()
    const location=useNavigate()
    const [password, setpassword] = useState('');
    const [Newpassword, setNewpassword] = useState('');
    const [autoGeneratedPassword, setautoGeneratedPassword] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [type, settype] = useState('password');
    const [AutoType, setAutoType] = useState('password');
    const [ConfirmType, setConfirmType] = useState('password');
    const [loading, setloading] = useState(false)
    const [OverallError, setOverallError] = useState('')
    const [invalidAutoPassword, setinvalidAutoPassword] = useState('')
    const [toastErrorMessage,setToastErrorMessage] = useState("")

    /**
     * The handleSubmit function is used to handle form submission for resetting a user's password in a
     * React application.
     * @returns The function `handleSubmit` does not return anything.
     */
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setsubmitSelected(true);
        setOverallError('')
        setloading(true)
        if(autoGeneratedPassword===''||password===''||Newpassword===''){
            setloading(false)
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        if(invalidAutoPassword !==''){
            setloading(false)
            setToastErrorMessage("Current Password is incorrect");
            return;
        }

        if(Newpassword?.length>0&&password!==Newpassword)
        {
            setloading(false)
            setToastErrorMessage("New Password and Confirm Password do not match.");
            return;
        }
        try {
            const payload={
                "confirm_password":password,
                "new_password": Newpassword,
                "old_password": autoGeneratedPassword  
            }
            const email = localStorage.getItem('email');
            const ResetResponse = await dataService.PatchAPI(payload, `users/reset-password/${email}`);
            setToastmessage('Password updated successfully');
            localStorage.clear();
            // setshow(false)
            location('/')
            Auth.signOut()
            dispatch(logout())
        } catch (error) {
            setloading(false)
            setToastErrorMessage(error.response.data.message)
        }
        

    }

    return (
        <>

            <CardHeader noPadding>
                <div className='mainDataCntnrTop shadow-s13'>
                    <h5 class="pageHeader updatepassword">Update Password</h5>
                    <div class="flex items-center">
                        <button type="button" class="cancl-btn" tabindex="0"
                            onClick={() => location(`${'/profile/my-profile'}`)}>
                            Cancel</button>
                        <button type="submit" id="resetpwd-form"
                            style={{'width':loading?'96px':'auto'}}
                            class="actn-btn onboardInstitution" tabindex="0" onClick={(e) => { e.preventDefault(); handleSubmit(e); }}>
                            {!loading?'Update':<span>{<Loader />}</span>}
                        </button>
                    </div>
                </div>
                <div className='relative mainDataCntnrPageDiv scrollBlue_thick'>
                    <div class="flex justify-between">
                    </div>
                    <div class="w-full border p-4 pb-[40px] rounded">
                        <form className="w-full">
                            <div className="flex items-center mb-4">
                                <label for="autoPassWord" className="text-f7 font-normal text-[#031624] min-w-[190px] inline-flex">Current Password</label>
                                <div className="relative">
                                    <input 
                                        type={AutoType}
                                        onFocus={()=>{
                                            setsubmitSelected(false);
                                            setOverallError('')
                                            setinvalidAutoPassword('')

                                        }}
                                        value={autoGeneratedPassword}
                                        id="autoPassWord" 
                                        style={{border:`1px solid ${submitSelected &&autoGeneratedPassword===''||invalidAutoPassword!==''?'#FDA29B':'#D0D5DD'}`, 'width':'275px'}}
                                        onChange={(e)=>setautoGeneratedPassword(e.target.value)}
                                        className="w-full inpt-fld error_border" 
                                        autocomplete="off" 
                                        placeholder="Enter Current Password" />
                                    <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5">
                                        {AutoType==='text'?<img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={()=>setAutoType('password')} />
                                            :<img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>setAutoType('text')}/>}
                                    </button>
                                </div>
                            </div>
                            <div className="flex items-center mb-4">
                                <label for="newPassword" className="text-f7 font-normal text-[#031624] min-w-[190px] inline-flex">New Password</label>
                                <div className="relative">
                                    <input 
                                        type={type}
                                        onChange={(e)=>setpassword(e.target.value)} 
                                        value={password} 
                                        id="newPassword" 
                                        style={{border:`1px solid ${submitSelected &&password===''?'#FDA29B':'#D0D5DD'}`, 'width':'275px'}}
                                        onFocus={()=>{
                                            setsubmitSelected(false);
                                            setOverallError('')
                                            setinvalidAutoPassword('')

                                        }}
                                        className="w-full inpt-fld error_border" autocomplete="off" placeholder="Enter New Password" />
                                    <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5">
                                        {type==='text'?<img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={()=>settype('password')} />
                                            :<img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>settype('text')}/>}
                                    </button>
                                </div>  
                            </div>
                            <div class="update-passwrd-msg">
                                <p className="text-f1 font-normal text-[#42526e]">Please make sure your password includes the following:</p>
                                <ul className="mt-2 pl-2">
                                    {Object.keys(passwordCriteria).map((criteria)=>(
                                        <li className="flex items-center mb-1" key={criteria}>
                                            <span>
                                                <img src={!passwordCriteria[criteria]["regex"].test(password)?`/images/login-bulletPOint.svg`:`/images/otp-tick.svg`} alt="img" loading="lazy" className="password-weak" id={criteria} />
                                            </span>
                                            <span className="text-f1 font-normal text-[#42526e] pl-[11px]"> {criteria}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="flex items-center mb-4">
                                <label for="ConformNewPassword" className="text-f7 font-normal text-[#031624] min-w-[190px] inline-flex">Confirm New Password</label>
                                <div className="relative">
                                    <input 
                                        type={ConfirmType} 
                                        onChange={(e)=>setNewpassword(e.target.value)} 
                                        style={{border:`1px solid ${(submitSelected &&Newpassword==='' || Newpassword?.length>0&& Newpassword!==password)?'#FDA29B':'#D0D5DD'}`, 'width':'275px'}}
                                        value={Newpassword}
                                        onFocus={()=>{
                                            setsubmitSelected(false);
                                            setOverallError('')
                                            setinvalidAutoPassword('')

                                        }}
                                        id="ConformNewPassword" 
                                        className="w-full inpt-fld error_border" 
                                        autocomplete="off"
                                        placeholder="Enter New Password" />
                                    <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5">
                                        {ConfirmType==='text'?<img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={()=>setConfirmType('password')} />
                                            :<img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>setConfirmType('text')}/>}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div></div >
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </CardHeader>          </>
    );
}

export default UpdateProfilePassword;
